import Vue from 'vue'
import trackService from '@/service/track'
import { isInViewPort } from '@/utils'

/**
 * 追踪用户行为的自定义指令
 * 文档 http://ued.local.17173.com/wiki/pages/viewpage.action?pageId=97943554
 * 
 * 用法一：链接或按扭的点击统计（用于在模板直出中）
 * 需要在链接上加上指令 v-track:link="9" ，9 为标记元素位置的 key
 * 同时在链接上加属性 data-track-vid="789"，789 为该链接视频的 oldVid
 * 示例：
 * <a v-track:link="9" data-track-vid="789" href="#"></a>
 *
 * 用法二：链接或按扭的点击统计（用于在vue模板中，指令值无法使用变量的情况）
 * 需要在链接上加上指令 v-track:link
 * 然后在链接上加属性 data-track-key="9", 9 为标记元素位置的 key
 * 最后在链接上加属性 data-track-vid="789"，789 为该链接视频的 oldVid
 * 示例：
 * <a v-track:link data-track-key="9" data-track-vid="789" href="#"></a>
 * 
 * 用法三：模块曝光统计
 * 需要在模块外层加指令 v-track:expose
 * 同时在子元素a标签内加 data-track-vid="789"
 * <div class="mod-box" v-track:expose><a data-track-vid="789" href="#"></a></div>
 */
Vue.directive('track', {
  bind: function(el, binding) {
    const arg = binding.arg
    const key = typeof binding.value !== 'undefined' ? binding.value : +el.getAttribute('data-track-key')
    // 链接或按扭的点击统计
    if (arg === 'link') {
      el.addEventListener('click', () => {
        trackService(1, {
          resCode: key,
          targetOldVid: el.getAttribute('data-track-vid')
        })
      })
    }
    // 区域下的链接点击统计
    if (arg === 'block') {
      // const links = el.querySelectorAll('a')
      // links.forEach(link => {
      //   link.addEventListener('click', () => {
      //     window._jc_ping.push(['_trackBlockClick', key, window.location.href])
      //   })
      // })
    }
  },
  inserted: function(el, binding) {
    if (binding.arg !== 'expose') return
    // 模块曝光统计，模块在可视区域内里记一次曝光
    let isExposed = false
    function check() {
      if (isExposed || !isInViewPort(el)) return

      let vidArr = []
      const links = el.querySelectorAll('a')
      links.forEach(link => {
        const vid = link.getAttribute('data-track-vid')
        if (vid) {
          vidArr.push(link.getAttribute('data-track-vid'))
        } 
      })
      trackService(2, {
        targetOldVids: vidArr
      })
      isExposed = true
      window.removeEventListener('scroll', check)
      window.removeEventListener('resize', check)
    }

    check()
    if (isExposed) return
    window.addEventListener('scroll', check)
    window.addEventListener('resize', check)
  }
})
